import { observable, action, computed } from 'mobx'
import RootStore from './RootStore'
import { Language } from '../models/Enums'
export interface IUser {
	userId: number
	companyId: number
	email: string
	name: string
}
export class UserStore {
	
	@observable public languageSettings: { language: Language }
	@observable public rootStore: RootStore
	@observable public user: IUser

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore

		let hrefQuery = new URLSearchParams(document.location.search);
		if(hrefQuery.get("lang") === "en") {
			localStorage.setItem('userLanguage', 'English' as Language)
			this.languageSettings = { language: 'English'}
		} else {
			const userLanguage = localStorage.getItem('userLanguage') as Language
			this.languageSettings = { language: userLanguage || 'Svenska'}
		}
		this.resetUser()
	}

	@computed get name() {
		return this.user.name
	}

	@computed get userId() {
		return this.user.userId
	}

	@action setLanguage(language: Language): void {
		this.languageSettings.language = language
		localStorage.setItem('userLanguage', this.languageSettings.language)
	}

	@action updateUser(userInfo?: any) {
		this.user = {
			userId: userInfo.id,
			companyId: userInfo.companyId,
			email: userInfo.email,
			name: userInfo.name
		}
	}

	@action resetUser() {
	
		this.user = {
			userId: -1,
			companyId: -1,
			email: '',
			name: ''
		}
	}
}
